import { useTranslations } from "next-intl";
import type { ReactElement } from "react";
import { LINKEDIN_HREF, YOUTUBE_HREF } from "./developers-funnel-content";

export function YouTubeLogo(): ReactElement {
  return (
    <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden={true}>
      <path
        fill="currentColor"
        d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.5 31.5 0 0 0 24 12a31.5 31.5 0 0 0-.5-5.8ZM9.8 15.5v-7L16 12l-6.2 3.5Z"
      />
    </svg>
  );
}

function LinkedInLogo(): ReactElement {
  return (
    <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden={true}>
      <path
        fill="currentColor"
        d="M20.5 2h-17A1.5 1.5 0 0 0 2 3.5v17A1.5 1.5 0 0 0 3.5 22h17a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 20.5 2ZM8 19H5v-9h3v9ZM6.5 8.3A1.8 1.8 0 1 1 6.5 4.8a1.8 1.8 0 0 1 0 3.5ZM19 19h-3v-4.4c0-2.4-2.8-2.2-2.8 0V19h-3v-9h3v1.4c1.4-2.5 6-2.7 6 2.4V19Z"
      />
    </svg>
  );
}

/** YouTube (icon + label) and LinkedIn sit as one social cluster. */
export function DevelopersFunnelSocial({
  youtubeLabel,
}: {
  readonly youtubeLabel: string;
}): ReactElement {
  const t = useTranslations("public.developersFunnelSocial");
  return (
    <div className="dvf-footer-social">
      <a
        className="dvf-footer-social-link dvf-footer-social-youtube"
        href={YOUTUBE_HREF}
        target="_blank"
        rel="noreferrer"
      >
        <YouTubeLogo />
        <span>{youtubeLabel}</span>
      </a>
      <a
        className="dvf-footer-social-link dvf-footer-social-linkedin"
        href={LINKEDIN_HREF}
        target="_blank"
        rel="noreferrer"
        aria-label={t("linkedin")}
      >
        <LinkedInLogo />
      </a>
    </div>
  );
}
